<template>
     <div class="form-div ">
        <v-card class="col-lg-8  col-xl-6 col-md-6 blue-text">
          <v-row class=" justify-center">
            <h2 class="blue-text text-center mt-10">
              Great...! Tell us about them.
            </h2>
        </v-row>
        <v-form class="justify-center mt-3" ref="form" v-model.trim="valid">
            <v-row class="justify-center">
              <v-col md="11" sm="12" cols="12">
                <label for="" class="tiny-font font text-gray">Contact’s First Name</label>
                <v-text-field
                    solo
                    type="text"
                    required
                    :rules="rules"
                    v-model.trim="firstName"
                ></v-text-field>
               
            </v-col>
            <v-col  md="11" sm="12" cols="12">
                <label for="" class="tiny-font font text-gray">Contact’s Last Name</label>
                  <v-text-field
                    solo
                    type="text"
                    required
                    :rules="rules"
                    v-model.trim="lastName"
                ></v-text-field>
                
            </v-col>
            <v-col md="11"  sm="12" cols="12">
                <label for="" class="tiny-font font text-gray">Contact’s Company Email</label>
              
                  <v-text-field
                    solo
                    v-model.trim="email"
                    :rules="emailRules"
                    type="email"
                    required
                ></v-text-field>
            </v-col>
            <v-col  md="11" sm="12" cols="12">
                <label for="" class="tiny-font font text-gray">Contact’s Title with the Company</label>
                 <v-text-field
                    solo
                    type="text"
                    required
                    :rules="rules"
                    v-model.trim="companyName"
                ></v-text-field>
              
            </v-col>
            </v-row>
           <v-col  md="12" sm="12" cols="12" class="d-flex justify-end" align="end">
                <v-btn depressed class="button-blue mt-2 ml-3" @click="submit">
                    Submit 
                </v-btn>
            </v-col>
        </v-form>
          <div class="text-center">
            <v-dialog
            v-model.trim="dialog"
            width="800"
            class="success-modal"
            >
            <v-card>
                <v-card-text class="success-modal" >
                    <div class="text-center">
                   <svg width="201" height="184" viewBox="0 0 201 184" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M196.333 33.7502C195.294 32.9243 194.06 32.3791 192.75 32.1669C191.113 32.0381 189.469 32.0381 187.833 32.1669L172.666 33.6669C164.333 34.3336 156 34.7502 147 34.9169C134.083 34.9169 112.166 32.5002 108.333 34.9169C105.144 39.3254 102.513 44.1118 100.5 49.1669L83.833 79.0836C81.9339 82.4979 80.5575 86.1777 79.7497 90.0002C79.4391 91.6249 79.6508 93.3062 80.3543 94.8031C81.0579 96.3001 82.2173 97.5359 83.6664 98.3336C85.0594 98.9768 86.5541 99.3717 88.083 99.5002C90.3591 99.6257 92.6403 99.6257 94.9164 99.5002H112.833C126.666 99.5002 140.75 101.584 154.5 102.167C160.662 102.5 166.838 102.5 173 102.167C174.476 102.024 175.903 101.563 177.184 100.815C178.464 100.066 179.567 99.0494 180.416 97.8336C182.482 94.3144 184.132 90.567 185.333 86.6669L197.916 52.5002C199.113 49.2052 199.815 45.751 200 42.2502C200.049 40.6513 199.746 39.0612 199.112 37.5923C198.478 36.1235 197.53 34.8119 196.333 33.7502ZM147.083 41.6669C155.416 41.6669 164.416 41.6669 173.083 41.6669L181 41.0836L154.833 59.0002C153 60.2502 149.833 63.0002 146.5 65.0002C145 65.9169 143.75 66.8336 142.583 66.5836L137.833 61.5002L122 45.9169C121 44.8336 119.333 42.5836 117.416 40.7502C127.416 41.0836 137.25 41.6669 147.083 41.6669ZM191.666 43.3336C191.301 45.5717 190.657 47.7554 189.75 49.8336L176.416 83.8336C175.916 85.0836 173.416 89.4169 172.25 92.1669C172.118 92.5042 171.89 92.795 171.593 93.0026C171.296 93.2102 170.945 93.3254 170.583 93.3336C165.333 93.3336 160 93.3336 154.666 93.3336C140.583 92.5836 126.416 90.9169 112.5 90.5836H88.333C89.1966 88.0606 90.3134 85.6315 91.6664 83.3336C91.6664 83.3336 111.416 48.7502 112 46.4169L133.333 66.6669C134.333 67.5836 136.083 69.7502 137.833 71.2502C138.964 72.2791 140.342 72.9969 141.833 73.3336C144.351 73.579 146.878 72.9619 149 71.5836C152.235 69.4209 155.351 67.0841 158.333 64.5836C158.333 64.5836 189.666 41.5836 191.666 39.5836C191.936 40.1719 192.076 40.8114 192.076 41.4586C192.076 42.1057 191.936 42.7453 191.666 43.3336Z" fill="#3397FA"/>
                        <path d="M67.0832 51.5004C67.8422 51.4787 68.5629 51.1619 69.0919 50.6172C69.621 50.0726 69.9169 49.3431 69.9166 48.5837C69.9076 48.178 69.8141 47.7786 69.6421 47.4111C69.47 47.0436 69.2231 46.716 68.9172 46.4494C68.6113 46.1827 68.2532 45.9828 67.8656 45.8624C67.4781 45.7421 67.0697 45.7039 66.6665 45.7504C52.7499 44.0837 32.4999 47.0004 31.9999 49.9171C31.8785 50.5911 32.0298 51.2858 32.4205 51.8484C32.8111 52.4109 33.4092 52.7953 34.0832 52.9171C49.9999 58.3337 58.3332 53.0837 67.0832 51.5004Z" fill="#3397FA"/>
                        <path d="M23.7499 73.2494C23.7706 73.5856 23.859 73.9141 24.0098 74.2153C24.1607 74.5165 24.3708 74.784 24.6277 75.002C24.8845 75.2199 25.1828 75.3837 25.5045 75.4835C25.8262 75.5833 26.1648 75.617 26.4999 75.5827C31.9999 75.5827 37.4165 76.4993 43.1665 76.666C45.4999 76.666 47.8332 76.666 50.1665 76.666L57.1665 76.0827C62.6665 75.5827 68.0832 74.8327 73.8332 74.2493C74.6067 74.2493 75.3486 73.9421 75.8956 73.3951C76.4426 72.8481 76.7499 72.1062 76.7499 71.3327C76.7499 70.5591 76.4426 69.8173 75.8956 69.2703C75.3486 68.7233 74.6067 68.416 73.8332 68.416C68.3332 67.916 62.8332 67.2493 57.1665 66.916C54.4165 66.666 52.0832 66.666 49.9999 66.666C47.9165 66.666 45.2499 66.666 42.9165 67.166C37.2499 67.916 31.9165 69.166 26.2499 70.3327C25.8834 70.3275 25.5202 70.4031 25.1861 70.5539C24.8521 70.7047 24.5552 70.9272 24.3167 71.2055C24.0782 71.4838 23.9037 71.8111 23.8058 72.1643C23.7078 72.5175 23.6887 72.8879 23.7499 73.2494Z" fill="#3397FA"/>
                        <path d="M57.6667 114.917C45.6667 114.917 32.6667 113.167 20.75 114.083C18.8333 114.083 16.75 114.083 14.8333 114.083C13.5833 107.5 12.3333 101 11.3333 94.4167C10.5377 88.8917 10.037 83.3282 9.83333 77.75C9.83333 70.8333 9.83333 63.9167 9.83333 57.0833C9.83333 50.25 10.9167 43.3333 11.8333 36.4167C12.0941 33.3421 12.6523 30.3002 13.5 27.3333C14.0984 25.0417 15.4482 23.0171 17.3333 21.5833C21.1439 19.2131 25.3498 17.5477 29.75 16.6667C36.8192 15.0263 43.9674 13.7469 51.1667 12.8333C59.5 11.4167 68.5 10.4167 77.1667 9.58333C90.25 8.33333 103.417 7.41667 116.667 6.66667C122.417 6.66667 128.333 6.08333 134.083 6.25C137.917 6.25 141.75 6.5 145.583 7C147.627 7.18916 149.658 7.49522 151.667 7.91667C152.832 8.12899 153.957 8.52265 155 9.08333C157.29 10.1117 159.272 11.7203 160.75 13.75C161.788 16.1409 162.3 18.7272 162.25 21.3333C162.293 22.0038 162.595 22.6312 163.093 23.0824C163.591 23.5336 164.245 23.773 164.917 23.75C165.252 23.7396 165.583 23.6616 165.888 23.5207C166.192 23.3798 166.466 23.1789 166.691 22.93C166.917 22.6811 167.09 22.3893 167.2 22.072C167.311 21.7547 167.356 21.4185 167.333 21.0833C167.454 17.6752 166.799 14.2843 165.417 11.1667C163.539 8.20595 160.888 5.81435 157.75 4.25C156.261 3.41894 154.662 2.80177 153 2.41667C150.75 1.83333 148.417 1.58333 146.333 1.25C142.417 0.666666 138 0.333333 134.333 0.0833333C128.25 -7.76102e-08 122.25 0 116.667 0C103.333 0 90.0833 0.666666 76.8333 1.5C68 2.08333 59.0833 2.83333 50.25 4.08333C42.9167 5.08333 35.0833 5.75 27.75 7.5C22.4298 8.75378 17.3589 10.8949 12.75 13.8333C9.7623 15.9224 7.42307 18.8103 6 22.1667C4.27252 26.3814 3.12321 30.8104 2.58333 35.3333C1.58333 42.4167 0.916667 49.5 0.5 56.6667C0.0833333 63.8333 0 71 0 78.1667C0.175387 84.1129 0.732085 90.0417 1.66667 95.9167C2.91667 104.25 4.83333 113.083 6.5 121.667C7.19617 126.178 8.48509 130.577 10.3333 134.75C11.8817 138.152 14.3677 141.043 17.5 143.083C22.4164 145.762 27.7835 147.513 33.3333 148.25C41.145 149.374 49.0247 149.958 56.9167 150C64.0833 150 71.25 150 78.4167 150C77.0226 152.666 75.8788 155.456 75 158.333C74.4493 160.693 74.0595 163.087 73.8333 165.5C73.8333 169 73.8333 172.083 73.25 174.417C66.1667 175.25 59.1667 176.333 52.3333 177.583C51.7302 177.74 51.2038 178.108 50.8512 178.622C50.4986 179.136 50.3436 179.76 50.4146 180.379C50.4856 180.998 50.778 181.57 51.2378 181.991C51.6976 182.411 52.2938 182.651 52.9167 182.667C58.25 182.667 63.75 182.667 69.5833 182.667L81.6667 183.333C85.75 183.333 90 183.333 93.75 183.75C97.5 184.167 101.417 183.75 105.5 183.75C113.833 183.75 123.167 182.25 132.333 181.583C133.092 181.562 133.813 181.245 134.342 180.7C134.871 180.155 135.167 179.426 135.167 178.667C135.167 177.893 134.859 177.151 134.312 176.604C133.765 176.057 133.024 175.75 132.25 175.75L113.583 175C113.583 172.583 113 169.667 112.417 166.667C111.973 164.211 111.36 161.788 110.583 159.417C109.348 156.158 107.843 153.008 106.083 150C156.083 149.083 163.167 152.25 165.917 139C172 109 167.083 116.667 57.6667 114.917ZM101 159.75C101.242 161.303 101.604 162.836 102.083 164.333C102.496 165.834 102.996 167.309 103.583 168.75C104.417 170.75 105.25 172.5 106 174.167L94.1667 173.667C89.75 173.667 85.25 173.667 80.6667 173.667C81.563 171.63 82.3421 169.543 83 167.417C83.5156 165.952 83.9059 164.447 84.1667 162.917C84.4786 161.406 84.6737 159.874 84.75 158.333C84.75 154.917 84.75 151.833 84.75 149.5H100.083C100.417 152.083 100.417 155.667 101 159.75ZM160 137.333C159.748 138.986 158.957 140.51 157.75 141.667H151.5C148 141.667 144.417 141.667 140.917 141.667H124.667H84.0833C75 141.667 66.1667 141.667 57.1667 141.167C49.7767 141.101 42.3994 140.545 35.0833 139.5C30.6078 138.793 26.3086 137.237 22.4167 134.917C20.8158 133.863 19.5676 132.354 18.8333 130.583C17.8122 128.266 17.0843 125.831 16.6667 123.333C30.2704 123.13 43.8749 123.686 57.4167 125L114.083 126.667C123.167 127.167 133.167 126.667 142.917 127.25C147.696 127.566 152.453 128.151 157.167 129H160.083C160.36 131.772 160.333 134.567 160 137.333Z" fill="black"/>
                        </svg>
                </div>
                <h2  class="text-center   mt-2">
                       Thank you. 
                </h2>
                <h2  class="text-center   mt-2">
                       We’ve sent a message to the individual you entered.
                </h2>
                <h2  class="text-center   mt-2">
                      We’ll let you know when they create a group account for your organization, so you can join it too.
                </h2>
                <div class="text-center align-center justify-center col-md-12 d-flex">
                      <h2  class=" col-md-4 text-center text-underline select-btn mt-10 pointer" @click="done">
                        Done
                    </h2>

                </div>
                  
                </v-card-text>
            </v-card>
            </v-dialog>
        </div>
            </v-card>
     </div>
</template>
<script>

import api from '../../../../services/api'
export default{
    data(){
        return{
            show1:false,
            dialog:false,
            email:'',
            companyName:'',
            lastName:'',
            firstName:'',
            valid:false,
            rules: [
                v => !!v || 'This field is required',
               
            ],
             emailRules: [
                v => !!v || 'This field is required',
                v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid',
            ],
        }
    },
    methods:{
        submit(){
            this.$refs.form.validate()
            if(this.valid){
                   let user = {
                        "companyName": this.companyName,
                        "firstName": this.firstName,
                        "lastName": this.lastName,
                        "email": this.email
                    }
                    api().post('/auth/contactEmployer', user).then((res)=>{
                    if(res){
                        this.dialog = true
                    }
               })

            }

        },
        done(){
            this.dialog = false;
           this.$router.replace('/login')
            
        }

    },
    computed:{
        path(){
            return this.$route.path;
        }
    }
}
</script>
<style>